<template>
  <div v-if="!hidden">
    <ColorVariantPicker
      :modelValue="colorIndex"
      :variants="variants"
      :gender="gender"
      :label="true"
      :thumbs="thumbs"
      :largeThumbs="largeThumbs"
      @change="colorChange"
    />

    <div v-if="!hideSize" class="-devider m-b-12 m-t-18" />
    <div v-if="!hideSize" class="d-flex flex-wrap">
      <label
        class="font-responsive-small h5 m-b-9 m-md-6 -small-caps"
        :class="{ '-clickable': sizeGuideLink }"
        @click.prevent="openFitGuide"
      >
        <span class="-bold">{{ insertString("Global", "Size") }}</span
        >&nbsp;
        <span
          class="-thin"
          :class="{ '-underline': sizeGuideLink }"
          v-if="fit !== 'Not applicable' && fit !== 'N/A' && fit !== ''"
          >({{ fit }}&nbsp;{{
            insertString("ProductPage", "Fits", "fit")
          }})</span
        >
      </label>
      <a
        v-if="sizeGuideLink && currentVariantSizes.length > 1"
        class="ml-auto font-responsive-small -blue -clickable"
        href="#pageTab-ProductFitSize"
        >{{ insertString("ProductPage", "SizeGuide") }}</a
      >
    </div>

    <SizeVariantPicker
      v-if="!hideSize"
      :modelValue="sizeVariantIndex"
      :variants="currentVariantSizes"
      :disabled="archived"
      :outlet="outlet"
      :grayOut="availibleInFuture"
      :label="true"
      :fit="fit"
      @change="sizeChange"
    />
  </div>
</template>

<script>
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import { ProductSortSizes } from '@/Scripts/lib/helper/productHelper.js';
import ColorVariantPicker from '@/Scripts/components/shared/VariantPickers/ColorVariantPicker.vue';
import SizeVariantPicker from '@/Scripts/components/shared/VariantPickers/SizeVariantPicker.vue';
// import SelectSizeModule from '@/Scripts/components/productcards/ProductCardDeprecated/Assets/SelectSizeModule.vue';

export default {
  mixins: [siteInfo],
  components: {
    ColorVariantPicker,
    SizeVariantPicker
    // SelectSizeModule
  },
  props: {
    variants: Array,
    colorIndex: Number,
    fit: String,
    gender: String,
    archived: Boolean,
    availibleInFuture: Boolean,
    sizeGuideLink: Boolean,
    hidden: Boolean,
    hideSize: Boolean,
    thumbs: {
      type: Boolean,
      default: true
    },
    largeThumbs: Boolean,
    presetSize: String,
    outlet: Boolean
  },
  data () {
    return {
      sizeVariantIndex: -1
    };
  },
  watch: {
    colorIndex () {
      if (this.sizeVariantIndex > -1) {
        this.$emit('size-change', this.sizeVariantIndex);
      }
    },
    presetSize: {
      immediate: true,
      handler (val) {
        if (val) {
          const index = this.currentVariantSizes.findIndex(x => x.Size === val);
          if (index > -1) {
            this.sizeVariantIndex = index;
          }
        }
      }
    }
  },
  computed: {
    currentVariant () {
      return this.variants[this.colorIndex];
    },
    currentVariantSizes () {
      if (this.currentVariant) {
        return ProductSortSizes(this.currentVariant.SizeVariations);
      }
      return [];
    },
    selectedSizeObject () {
      return this.currentVariantSizes[this.sizeVariantIndex];
    },
    selectedSize () {
      if (!this.selectedSizeObject) {
        return '';
      }
      return this.selectedSizeObject.Size;
    }
  },
  methods: {
    colorChange (e) {
      this.$emit('color-index-change', e);
    },
    sizeChange (e) {
      this.sizeVariantIndex = e;
      this.$emit('size-change', this.sizeVariantIndex);
    },
    sortBySize (arr) {
      return [...arr].sort((a, b) =>
        a.SizeSort > b.SizeSort ? 1 : b.SizeSort > a.SizeSort ? -1 : 0
      );
    },
    openSizeGuide () {
      eventBus.$emit('openPageSection', { section: 'ProductFitSize', state: 'size' });
    },
    openFitGuide () {
      eventBus.$emit('openPageSection', { section: 'ProductFitSize', state: 'fit' });
    }
  },
  mounted () {
    if (this.currentVariantSizes.length === 1) {
      this.sizeChange(0);
    }
  }
};

</script>
